const parseDate = (timestamp: string) => {
	const isSafari =
		typeof window === 'undefined'
			? false
			: /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

	if (isSafari) {
		const d = new Date(timestamp.replace(/ /g, 'T'))

		if (d.toString() === 'Invalid Date') {
			return new Date(timestamp)
		}

		return d
	}

	return new Date(timestamp)
}

export default parseDate
